import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { AxiosResponseCustom, useRestAPI } from "./axiosAPI"
import { useState } from "react"
import { backendPagination } from "src/types/pagination"

export type ProductData = {
    description: string | null,
    name: string | null,
    price: string | null,
    image: string | File
}

export type ProductDataExtended = {
    id: number,
    name: string,
    image: string | null,
    price: string,
    description: string
}



const QUERY_KEY = 'products'
export function useProductAPI({
    trigger,
    retryCount
}: {
    trigger?:boolean,
    retryCount?:number
}) {

    const api = useRestAPI()
    const [totalProductCount, setTotalProductCount] = useState(0)
    const queryclient = useQueryClient()
    // const [deleteRetryCount,setDeleteRetryCount] = useState(0)

    const {
        isLoading,
        isError,
        data: products,
        refetch: refetchProducts,
        isFetching,
        isFetched,
        error,
        isRefetchError,
        isFetchedAfterMount
    } = useQuery({
        queryKey: [QUERY_KEY,],
        queryFn: async () => {
            const response = await api.get< ProductDataExtended[] >({
                url: `${process.env.REACT_APP_BACKEND_URL}/products/product/list/`,
                mode: 'protected',
                params: {
                    
                }
            })
            if (response.success === false) {
                throw response.message
            }
            return response
        },
        refetchOnWindowFocus: false,
        retry: retryCount,
        enabled: trigger,


    })




    const { mutateAsync: createProduct, isPending: isCreatingProduct, failureCount: createfailureCount } = useMutation({
        mutationFn: async (Product: ProductData) => {

            const formData = new FormData();
            Object.keys(Product).forEach(key => {
                if (key === 'image') {
                    if (Product[key] instanceof File) {
                        formData.append(key, Product[key] as File);
                    }
                }  else {
                    // Append all other data as string
                    const value = Product[key as keyof ProductData];
                    formData.append(key, value !== null && value !== undefined ? String(value) : '');
                }
            })


            const response = await api.post<{}, {}>({
                url: `${process.env.REACT_APP_BACKEND_URL}/products/product/create/`,
                data: formData,
                mode: 'protected'
            })

            console.log(response)

            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && createfailureCount < 4) {
                console.log(
                    'error occured'
                )
                throw response
            }

            return response
        }
    })

    const { mutateAsync: updateProduct, isPending: isUpdatingProduct, failureCount: updateFailuirCount } = useMutation({
        mutationFn: async ({
            id,
            Product
        }: {
            id: string | number,
            Product: ProductData
        }) => {
            const formData = new FormData();
            Object.keys(Product).forEach(key => {
                if (key === 'image') {
                    if (Product[key] instanceof File) {
                        formData.append(key, Product[key] as File);
                    }
                }  else {
                    // Append all other data as string
                    const value = Product[key as keyof ProductData];
                    formData.append(key, value !== null && value !== undefined ? String(value) : '');
                }
            })
            const response = await api.patch<{}, {}>({
                url: `${process.env.REACT_APP_BACKEND_URL}/products/product/update/${id}/`,
                data: formData,
                mode: 'protected'
            })

            if (response.success === false  && updateFailuirCount < 4) {

                throw response
            }

            return response
        }, retry: 4
    })

    const { mutateAsync: deleteProductById, isPending: isDeleting, failureCount } = useMutation({
        mutationFn: async ({ productId }: { productId: string | number }) => {

            const response = await api.delete<{}>({
                url: `${process.env.REACT_APP_BACKEND_URL}/products/product/delete/${productId}/`,
                mode: 'protected'
            })

            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && failureCount < 4) {

                // setDeleteRetryCount((prev)=>prev+1)
                throw response
            }

            return response
        },
        retry: 4,

    })
    const { mutateAsync: readProductbyId, isPending: isReadingProduct, failureCount: empReadFailureCount } = useMutation({
        mutationFn: async ({ productId }: { productId: string | number }) => {

            const response = await api.get< ProductDataExtended >({
                url: `${process.env.REACT_APP_BACKEND_URL}/products/product/get/${productId}/`,
                mode: 'protected'
            })

            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && empReadFailureCount < 4) {

                // setDeleteRetryCount((prev)=>prev+1)
                throw response
            }

            return response
        },
        retry: 4,

    })




    return {
        isLoading,
        isError,
        products,
        refetchProducts,
        totalProductCount,
        isFetching,
        isFetched,
        error,
        isRefetchError,
        isFetchedAfterMount,
        isDeleting,
        createProduct,
        deleteProductById,
        readProductbyId,
        isReadingProduct,
        updateProduct,
        isUpdatingProduct
    }


}


export function useProductAPIs(){

    const api = useRestAPI()

    const { mutateAsync: downloadProductDatas, isPending: isDownloadingProductDatas, failureCount: failureProductDatas, isError: isErrorDownloadingProductDatas } = useMutation({
        mutationFn: async () => {

            const response = await api.get({
                url: `${process.env.REACT_APP_BACKEND_URL}/excel-upload/product-data-download/`,
                mode: 'protected',
                responseType: 'blob',
                
            })


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && failureProductDatas < 4) {

                // setDeleteRetryCount((prev)=>prev+1)
                throw response
            }
            if (response.success !== false) {
                const blob = new Blob([response as unknown as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Products.xlsx'; // Set the filename

                // Append to the document and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }

            return response
        },
        retry: 4,

    })

    return {
        downloadProductDatas,
        isDownloadingProductDatas,
    }

}
